/**
 * Redux Store Configuration
 * Centralized state management with Redux Toolkit
 */
import { configureStore } from '@reduxjs/toolkit';

// Import feature slices
import authReducer from '../../features/authentication/authSlice';
import dashboardReducer from '../../features/dashboard/dashboardSlice';
import membersReducer from '../../features/members/memberSlice';
import loansReducer from '../../features/loans/loanSlice';
import savingsReducer from '../../features/savings/savingsSlice';
import sharesReducer from '../../features/shares/sharesSlice';
import repaymentsReducer from '../../features/repayments/repaymentSlice';
import guarantorsReducer from '../../features/guarantors/guarantorSlice';
import accountingReducer from '../../features/accounting/accountingSlice';
import reportsReducer from '../../features/reports/reportSlice';
import notificationsReducer from '../../features/notifications/notificationSlice';
import settingsReducer from '../../features/settings/settingsSlice';
import usersReducer from '../../features/users/userSlice';

/**
 * Configure Redux store with all feature slices
 */
export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    members: membersReducer,
    loans: loansReducer,
    savings: savingsReducer,
    shares: sharesReducer,
    repayments: repaymentsReducer,
    guarantors: guarantorsReducer,
    accounting: accountingReducer,
    reports: reportsReducer,
    notifications: notificationsReducer,
    settings: settingsReducer,
    users: usersReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['auth/setCredentials'],
        ignoredPaths: ['auth.user.lastLogin'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
